define('views/modules/template/edit/calendar/template-calendar-item-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // parent
    'views/modules/calendar/calendar-item-panel',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // parent
    VCalendarItemPanel
) {

    var VTemplateCalendarItemPanel = VCalendarItemPanel.extend({

        tabs: [
            { id: 'details', title: 'Details', active: true, callback: 'showDetails' },
            { id: 'favorite', title: 'Favorite', callback: 'showFavorite' },
        ],
        defaultView: 'details',

        showDetails: function() { this.showContent('details'); },

        setModel: function(model) {
            if (!model) return;
            var attrs = model.attributes || model;
            this.model.reset(attrs);
            return this;
        },

        resetModel: function(attrs) {
            this.model.reset(attrs);
            return this;
        },

        /////////////
        // events  //
        /////////////

        onClosePanel: function() {
            this.view.details.setPristine();
        },

        onModelReset: _.noop

    });

    return VTemplateCalendarItemPanel;
});

